<template>
  <div class="web-page-container">
    <StarTabs :tabs="['配置', '统计分析', '最近任务']" v-model="tabActiveIndex" />

    <div class="web-page-mid">
      <div class="web-page-inner">
        <wemeida-config :id="id" :type="type" ref="wemeida" />
        <!-- <Statistics v-if="tabActiveIndex === 1" />
        <RecentTask v-if="tabActiveIndex === 2" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import wemeidaConfig from '../wemeidaConfig'
import Statistics from '../Statistics'
import RecentTask from '../RecentTask'
import StarTabs from '@/components/StarTabs'

export default {
  components: { wemeidaConfig, Statistics, RecentTask, StarTabs },
  props: {
    type: {
      default: ''
    },
    id: {
      default: ''
    }
  },
  data() {
    return {
      // spiderClassId: '',
      // tabActiveIndex: 0
    }
  },
  created() {
    let { spiderClassId } = this.$route.query
    if (spiderClassId) {
      this.spiderClassId = Number(spiderClassId)
    }
  },
  methods: {
    reload() {
      this.$refs['wemeida'].reload()
    }
  }
}
</script>

<style lang="less" scoped>
.web-page-container {
  width: 100%;

  .web-page-mid {
    padding: 16px;

    .web-page-inner {
      width: 100%;
    }
  }
}
</style>
